import Vue from "vue";
import VueRouter from "vue-router";
import IphoneIndex from "@/components/iphone/index";
import PcIndex from "@/components/pc/index";

Vue.use(VueRouter);
export default new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "pcIndex",
      component: PcIndex
    },
    {
      path: "/pcIndex",
      name: "PcIndex",
      component: PcIndex
    },
    {
      path: "/iphoneIndex",
      name: "IphoneIndex",
      component: IphoneIndex
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js